import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "toolbar", "count", "button"]

  connect() {
    this.refresh()
  }

  toggleRow() {
    this.refresh()
  }


  clear() {

    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })

    this.refresh()
  }


  refresh() {

    const selected = this.selectedCount
    const isActive = selected > 0

    this.countTarget.textContent = selected

    this.toolbarTarget.hidden = !isActive
    this.buttonTargets.forEach((button) => {
      button.disabled = !isActive
    })
  }

  get selectedCount() {

    return this.checkboxTargets.filter(
      checkbox => checkbox.checked
    ).length

  }
}
